import { ConstructKey } from 'components/charts/common/util'
import { SeriesItem } from 'stores/types'

export const isConstructKey = (
  c: SeriesItem,
): c is Omit<ConstructKey, 'frequency'> => 'middle' in c
